import { observer } from "mobx-react-lite";
import { FC } from "react";
import { BsArrowRight } from "react-icons/bs";
import { useStore } from "store";
import { GUEST_MARKUP } from "store/cart";
import { IMenuItem } from "types/menu";
import { roundToNearestHalf } from "utils/numberHelpers";

const DiscountLabel: FC<{ item: IMenuItem }> = observer(({ item }) => {
	const { cart } = useStore();
	const showDiscount = !item?.isStaffOnly && !item.isStaffOnly;
	return showDiscount ? (
		<div className="flex">
			<span className="border-secondary border border-r-0 rounded-l px-1 py-0.5">{roundToNearestHalf(item.price)}pts</span>
			<span className="border-secondary border px-1 py-0.5 flex items-center">
				<BsArrowRight />
			</span>
			<span className="bg-secondary text-black border border-l-0 border-secondary rounded-r px-1 py-0.5">
				{(cart.priceMultiplier * item.price).toFixed(2)}pts
			</span>
		</div>
	) : (
		<span className="text-secondary border border-secondary rounded px-1 py-0.5">{roundToNearestHalf(GUEST_MARKUP * item.price)}pts</span>
	);
});

export default DiscountLabel;
